import { IDirective, IScope } from 'angular';
import * as tippy from 'tippy.js';
import './gmc-tooltip.scss';

interface IGmcTooltipScope extends IScope {
  gmcTooltip: any;
}

export function gmcTooltipDirective(): IDirective {
  return {
    restrict: 'A',
    link: function postLink( scope: IGmcTooltipScope, $element, attrs ) {
      let tooltip;
      let tooltipText;
      attrs.$observe('gmcTooltip', ( text: string ) => {
        destroyTooltip();
        tooltipText = text;
        createTooltip();
      });
      attrs.$observe('gmcTooltipTheme', () => {
        destroyTooltip();
        createTooltip();
      });
      scope.$on('$destroy', () => {
        tooltip.destroyAll();
      });

      function createTooltip() {
        attrs.$set('title', tooltipText);
        tooltip = tippy($element[ 0 ], {
          arrow: true,
          placement: attrs.gmcTooltipPlacement || 'top',
          theme: attrs.gmcTooltipTheme || 'gmc-tooltip',
        });
      }

      function destroyTooltip() {
        if ( tooltip ) {
          tooltip.destroyAll();
          tooltip = null;
        }
      }
    }
  };
}

gmcTooltipDirective.$inject = [];



// WEBPACK FOOTER //
// ./app/ui/gmc-tooltip/gmc-tooltip.directive.ts